import * as React from 'react';
import { Button, Dropdown } from 'semantic-ui-react';
import { FiMoreVertical } from 'react-icons/fi';

// Components
import SelectedTimesheetIsApprovedGate from 'components/SelectedTimesheetIsApprovedGate';
import SelectedTimesheetIsUnapprovedGate from 'components/SelectedTimesheetIsUnapprovedGate';

import TimesheetEntryDuplicateDropdownItem from './components/TimesheetEntryDuplicateDropdownItem';
import TimesheetEntrySplitDropdownItem from './components/TimesheetEntrySplitDropdownItem';

interface Props {
    rowId: number;
}

export class TimesheetEntryMoreDropdown extends React.PureComponent<Props> {
    render() {
        const { rowId } = this.props;
        return (
            <Dropdown
                trigger={
                    <Button
                        circular
                        icon
                        style={{
                            paddingTop: 7,
                            paddingRight: 0,
                            paddingBottom: 7,
                            paddingLeft: 0,
                            margin: 0,
                            background: 'transparent',
                            boxShadow: 'none'
                        }}
                    >
                        <FiMoreVertical
                            size="22"
                            style={{ verticalAlign: 'middle' }}
                        />
                    </Button>
                }
                className="inverted"
                direction="right"
                selectOnBlur={false}
                defaultValue={false}
                icon={null}
            >
                <Dropdown.Menu>
                    <SelectedTimesheetIsApprovedGate>
                        <Dropdown.Item text="View" disabled />
                    </SelectedTimesheetIsApprovedGate>
                    {/*
            <Dropdown.Item text="Edit" />
          */}
                    <SelectedTimesheetIsUnapprovedGate>
                        <TimesheetEntryDuplicateDropdownItem rowId={rowId} />
                    </SelectedTimesheetIsUnapprovedGate>
                    <SelectedTimesheetIsUnapprovedGate>
                        <TimesheetEntrySplitDropdownItem
                            timesheetEntryUuid={rowId}
                        />
                    </SelectedTimesheetIsUnapprovedGate>
                    {/*
            <Dropdown.Item text="Split" />
            <Dropdown.Item text="Delete" />
          */}
                </Dropdown.Menu>
            </Dropdown>
        );
    }
}

export default TimesheetEntryMoreDropdown;
